// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aw5U8","title":"styles_title__2BfEk"};